<script lang="ts">
	import { page } from '$app/stores';

	// Site-wide structured data: rendered ONCE in the marketing layout.
	// Emits an Organization and a WebSite JSON-LD block. All values are real —
	// no fabricated social profiles or contact details.
	//
	// Origin is resolved the same way Seo.svelte resolves canonical/og:url,
	// so the absolute URLs (logo, sameAs targets) stay correct per environment.
	let origin = $derived($page.url.origin);

	let organizationJsonLd = $derived({
		'@context': 'https://schema.org',
		'@type': 'Organization',
		name: 'Samlla',
		url: origin,
		// The 512×512 PWA icon is the stable public PNG of the Samlla mark.
		// Its dimensions satisfy structured-data image requirements.
		logo: `${origin}/icons/pwa-512x512.png`
		// SML-46: no contactPoint until a general support inbox is confirmed by
		// readback; the privacy contact lives only in the privacy policy.
	});

	let websiteJsonLd = $derived({
		'@context': 'https://schema.org',
		'@type': 'WebSite',
		name: 'Samlla',
		url: origin
		// No SearchAction: the site has no on-site search endpoint.
	});
</script>

<svelte:head>
	{@html `<script type="application/ld+json">${JSON.stringify(organizationJsonLd)}</script>`}
	{@html `<script type="application/ld+json">${JSON.stringify(websiteJsonLd)}</script>`}
</svelte:head>
